import {
  TRESPONSE_BENCHMARKING_CONFIG,
  TRESPONSE_EFFICIENCY_CONFIG,
  TRESPONSE_EXPECTED_DATE_CONFIG,
  TRESPONSE_OTL_OPL_CONFIG,
  TRESPONSE_SED_CONFIG,
  TRESPONSE_TNA_TARGET_UPDATES_CONFIG,
  TRESPONSE_AUTO_PLAN_CONFIG,
} from '@monorepo/types';

export type TFactoryConfigState = {
  factoryEfficiencyConfig: TRESPONSE_EFFICIENCY_CONFIG | null;
  showEfficiencyLoader: boolean;
  factoryBenchmarkingConfig: TRESPONSE_BENCHMARKING_CONFIG | null;
  showBenchmarkingLoader: boolean;
  factoryOtlOplConfig: TRESPONSE_OTL_OPL_CONFIG | null;
  showOtlOplLoader: boolean;
  factorySedConfig: TRESPONSE_SED_CONFIG | null;
  showSedLoader: boolean;
  factoryExpectedDateConfig: TRESPONSE_EXPECTED_DATE_CONFIG | null;
  showExpectedDateLoader: boolean;
  showTnaTargetUpdatesConfigLoader: boolean;
  tnaTargetUpdatesConfig: TRESPONSE_TNA_TARGET_UPDATES_CONFIG | null;
  showAutoPlanConfigLoader: boolean;
  autoPlanConfig: TRESPONSE_AUTO_PLAN_CONFIG | null;
};

export const TFactoryConfigActionType = {
  GetFactoryEfficiencyConfig: 'GET_FACTORY_EFFICIENCY_CONFIG' as const,
  GetFactoryEfficiencyConfigSuccess: 'GET_FACTORY_EFFICIENCY_CONFIG_SUCCESS' as const,
  GetFactoryEfficiencyConfigFailure: 'GET_FACTORY_EFFICIENCY_CONFIG_FAILURE' as const,
  SetEfficiencyLoader: 'SET_EFFICIENCY_LOADER' as const,
  SetTnaTargetUpdatesConfigLoader: 'SET_TNA_TARGET_UPDATES_CONFIG_LOADER' as const,
  UpdateFactoryEfficiencyConfig: 'UPDATE_FACTORY_EFFICIENCY_CONFIG' as const,
  UpdateFactoryEfficiencyConfigSuccess: 'UPDATE_FACTORY_EFFICIENCY_CONFIG_SUCCESS' as const,
  UpdateFactoryEfficiencyConfigFailure: 'UPDATE_FACTORY_EFFICIENCY_CONFIG_FAILURE' as const,
  GetFactoryBenchmarkingConfig: 'GET_FACTORY_BENCHMARKING_CONFIG' as const,
  GetFactoryBenchmarkingConfigSuccess: 'GET_FACTORY_BENCHMARKING_CONFIG_SUCCESS' as const,
  GetFactoryBenchmarkingConfigFailure: 'GET_FACTORY_BENCHMARKING_CONFIG_FAILURE' as const,
  SetBenchmarkingLoader: 'SET_BENCHMARKING_LOADER' as const,
  UpdateFactoryBenchmarkingConfig: 'UPDATE_FACTORY_BENCHMARKING_CONFIG' as const,
  UpdateFactoryBenchmarkingConfigSuccess: 'UPDATE_FACTORY_BENCHMARKING_CONFIG_SUCCESS' as const,
  UpdateFactoryBenchmarkingConfigFailure: 'UPDATE_FACTORY_BENCHMARKING_CONFIG_FAILURE' as const,
  GetFactoryOtlOplConfig: 'GET_FACTORY_OTL_OPL_CONFIG' as const,
  GetFactoryOtlOplConfigSuccess: 'GET_FACTORY_OTL_OPL_CONFIG_SUCCESS' as const,
  GetFactoryOtlOplConfigFailure: 'GET_FACTORY_OTL_OPL_CONFIG_FAILURE' as const,
  SetOtlOplLoader: 'SET_OTL_OPL_LOADER' as const,
  UpdateFactoryOtlOplConfig: 'UPDATE_FACTORY_OTL_OPL_CONFIG' as const,
  UpdateFactoryOtlOplConfigSuccess: 'UPDATE_FACTORY_OTL_OPL_CONFIG_SUCCESS' as const,
  UpdateFactoryOtlOplConfigFailure: 'UPDATE_FACTORY_OTL_OPL_CONFIG_FAILURE' as const,
  GetFactorySedConfig: 'GET_FACTORY_SED_CONFIG' as const,
  GetFactorySedConfigSuccess: 'GET_FACTORY_SED_CONFIG_SUCCESS' as const,
  GetFactorySedConfigFailure: 'GET_FACTORY_SED_CONFIG_FAILURE' as const,
  SetSedLoader: 'SET_SED_LOADER' as const,
  UpdateFactorySedConfig: 'UPDATE_FACTORY_SED_CONFIG' as const,
  UpdateFactorySedConfigSuccess: 'UPDATE_FACTORY_SED_CONFIG_SUCCESS' as const,
  UpdateFactorySedConfigFailure: 'UPDATE_FACTORY_SED_CONFIG_FAILURE' as const,
  GetFactoryExpectedDateConfig: 'GET_FACTORY_EXPECTED_DATE_CONFIG' as const,
  GetFactoryExpectedDateConfigSuccess: 'GET_FACTORY_EXPECTED_DATE_CONFIG_SUCCESS' as const,
  GetFactoryExpectedDateConfigFailure: 'GET_FACTORY_EXPECTED_DATE_CONFIG_FAILURE' as const,
  // UpdateTnaTargetUpdatesConfig
  GetTnaTargetUpdatesConfig: 'GET_TNA_TARGET_UPDATES_CONFIG' as const,
  GetTnaTargetUpdatesConfigSuccess: 'GET_TNA_TARGET_UPDATES_CONFIG_SUCCESS' as const,
  GetTnaTargetUpdatesConfigFailure: 'GET_TNA_TARGET_UPDATES_CONFIG_FAILURE' as const,
  UpdateTnaTargetUpdatesConfig: 'UPDATE_TNA_TARGET_UPDATES_CONFIG' as const,
  UpdateTnaTargetUpdatesConfigSuccess: 'UPDATE_TNA_TARGET_UPDATES_CONFIG_SUCCESS' as const,
  UpdateTnaTargetUpdatesConfigFailure: 'UPDATE_TNA_TARGET_UPDATES_CONFIG_FAILURE' as const,
  GetAutoPlanConfig: 'GET_AUTO_PLAN_CONFIG' as const,
  GetAutoPlanConfigSuccess: 'GET_AUTO_PLAN_CONFIG_SUCCESS' as const,
  GetAutoPlanConfigFailure: 'GET_AUTO_PLAN_CONFIG_FAILURE' as const,
  SetAutoPlanConfigLoader: 'SET_AUTO_PLAN_CONFIG_LOADER' as const,
  UpdateAutoPlanConfig: 'UPDATE_AUTO_PLAN_CONFIG' as const,
  UpdateAutoPlanConfigSuccess: 'UPDATE_AUTO_PLAN_CONFIG_SUCCESS' as const,
  UpdateAutoPlanConfigFailure: 'UPDATE_AUTO_PLAN_CONFIG_FAILURE' as const,
  SetExpectedDateLoader: 'SET_EXPECTED_DATE_LOADER' as const,
  UpdateFactoryExpectedDateConfig: 'UPDATE_FACTORY_EXPECTED_DATE_CONFIG' as const,
  UpdateFactoryExpectedDateConfigSuccess: 'UPDATE_FACTORY_EXPECTED_DATE_CONFIG_SUCCESS' as const,
  UpdateFactoryExpectedDateConfigFailure: 'UPDATE_FACTORY_EXPECTED_DATE_CONFIG_FAILURE' as const,
  GetAllFactoryConfigs: 'GET_ALL_FACTORY_CONFIGS' as const,
  GetAllFactoryConfigsSucccess: 'GET_ALL_FACTORY_CONFIGS_SUCCESS' as const,
  GetAllFactoryConfigsFailure: 'GET_ALL_FACTORY_CONFIGS_FAILURE' as const,
};
